"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOPIC_LAYOUT_TYPE = void 0;
exports.TOPIC_LAYOUT_TYPE = {
    ONE_COLUMN: {
        displayName: 'One column, full width',
        value: 1,
        uncheckedClassName: 'single-column-icon-unchecked',
        checkedClassName: 'single-column-icon-checked',
    },
    TWO_COLUMN: {
        displayName: 'Two column',
        value: 2,
        uncheckedClassName: 'double-column-icon-unchecked',
        checkedClassName: 'double-column-icon-checked',
    },
    THREE_COLUMN: {
        displayName: 'Three column',
        value: 3,
        uncheckedClassName: 'three-column-icon-unchecked',
        checkedClassName: 'three-column-icon-checked',
    },
    TWO_ROW_T_80_1A_B_20_1A: {
        displayName: 'Stacked, large top',
        value: 14,
        uncheckedClassName: 'two-row-8020-icon-unchecked',
        checkedClassName: 'two-row-8020-icon-checked',
    },
    TWO_ROW_T_60_1A_B_40_1A: {
        displayName: 'Stacked, medium top',
        value: 15,
        uncheckedClassName: 'two-row-6040-icon-unchecked',
        checkedClassName: 'two-row-6040-icon-checked',
    },
    TWO_COLUMN_L_67_1A_R_33_1A: {
        displayName: 'Two column, narrow right',
        value: 11,
        uncheckedClassName: 'two-column-6733-icon-unchecked',
        checkedClassName: 'two-column-6733-icon-checked',
    },
    TWO_ROW_T_50_1A_B_50_2A: {
        displayName: 'Stacked, two block bottom',
        value: 18,
        uncheckedClassName: 'two-row-50T1AB502A-icon-unchecked',
        checkedClassName: 'two-row-50T1AB502A-icon-checked',
    },
    TWO_COLUMN_L_50_2A_R_50_1A: {
        displayName: 'Stacked with right column',
        value: 8,
        uncheckedClassName: 'two-column-50L2AR501A-icon-unchecked',
        checkedClassName: 'two-column-50L2AR501A-icon-checked',
    },
};
